import {autoserialize} from 'cerialize';

export class RLCountModel {
    @autoserialize public _id: string;
    @autoserialize public count: number;
    @autoserialize public filteredIds: string[];
}
